import React, { useState, useEffect } from 'react'
import { useNotify } from 'react-admin'
import { productServices } from 'src/services/reservation/product/product.service'
import { MultiSelectTreeView } from './TreeView'
import { Skeleton } from '@mui/material'

export const AdapterToDoRequestComponent = ({ tableName }) => {
  const notify = useNotify()
  const [loadingSkeletonMap, setLoadingSkeletonMap] = useState(false)
  const [optionsSkeletonMap, setOptionsSkeletonMap] = useState({})

  useEffect(() => {
    if (tableName.length !== 0) {
      ;(async () => {
        setLoadingSkeletonMap(true)
        try {
          const skeletonMap = await productServices.getSkeletonTable(tableName)
          setOptionsSkeletonMap(skeletonMap)
          setLoadingSkeletonMap(false)
        } catch (error) {
          notify(`skeleton not found`, { type: 'error' })
          setLoadingSkeletonMap(false)
          setOptionsSkeletonMap({})
          return null
        } finally {
          setLoadingSkeletonMap(false)
        }
      })()
    }
  }, [tableName])

  let isNull = { createReservation: {} }
  return (
    <>
      {loadingSkeletonMap ? (
        <Skeleton variant='rectangular' width={'100%'} height={400} />
      ) : (
        <MultiSelectTreeView skeleton={optionsSkeletonMap ? optionsSkeletonMap : isNull} />
      )}
    </>
  )
}
